import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { Store } from '@ngrx/store';
import { MmsAssistance } from '../../../models/mms-assistance';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
  selector: 'app-mms-assistance',
  templateUrl: './mms-assistance.component.html',
  styleUrls: ['./mms-assistance.component.css'],
  standalone: false
})
export class MmsAssistanceComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  mmsAssistance = new MmsAssistance();
  step: number;
  imeiPhone: number;
  brandPhone: string;
  modelPhone: string;
  system: string = 'iOS';
  activeCellularData: string = '1';
  androidVersion: string;
  otherSystem: string;

  errorImeiPhone: boolean;
  errorBrandPhone: boolean;
  errorModelPhone: boolean;
  errorAndroidVersion: boolean;
  errorOtherSystem: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.step = 1;
    this.formSubmitted = false;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number){
    this.step = step;
  }

  confirmation() {
    if (this.isValidForm() && this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission(this.mmsAssistance, this.procedureCode));
    }
  }

  private isValidForm() {
    let result = true;
    this.errorImeiPhone = false;
    this.errorBrandPhone = false;
    this.errorModelPhone = false;
    this.errorAndroidVersion = false;
    this.errorOtherSystem = false;

    this.mmsAssistance.phoneNumber = this.line.phoneNumber;
    this.mmsAssistance.step = 1;
    this.mmsAssistance.activeCellularData = this.activeCellularData == '1';
    this.mmsAssistance.system = this.system;
    this.mmsAssistance.androidVersion = null;
    this.mmsAssistance.brandPhone = null;
    this.mmsAssistance.imeiPhone = null;
    this.mmsAssistance.modelPhone = null;
    this.mmsAssistance.otherSystem = null;

    if (this.imeiPhone == undefined || this.imeiPhone.toString() == '' || this.imeiPhone.toString().length < 15) {
      this.errorImeiPhone = true;
    } else {
      this.mmsAssistance.imeiPhone = this.imeiPhone;
    }

    if (this.modelPhone == undefined || this.modelPhone == '') {
      this.errorModelPhone = true;
    } else {
      this.mmsAssistance.modelPhone = this.modelPhone;
    }

    if (this.brandPhone == undefined || this.brandPhone == '') {
      this.errorBrandPhone = true;
    } else {
      this.mmsAssistance.brandPhone = this.brandPhone;
    }

    if (this.system == 'Android' && (this.androidVersion == undefined || this.androidVersion == '')) {
      this.errorAndroidVersion = true;
    } else {
      this.mmsAssistance.androidVersion = this.androidVersion;
    }

    if (this.system == 'Autre' && (this.otherSystem == undefined || this.otherSystem == '')) {
      this.errorOtherSystem = true;
    } else {
      this.mmsAssistance.otherSystem = this.otherSystem;
    }

    if (
        this.errorImeiPhone == true ||
        this.errorBrandPhone == true ||
        this.errorModelPhone == true ||
        this.errorAndroidVersion == true ||
        this.errorOtherSystem == true
    ) {
      result = false;
    }

    return result;
  }
}
